module.exports = __webpack_public_path__ + "img/1.985ce331.jpg";